<script setup>
definePage({ meta: { ...PageMeta.Quotes.service.meta, pageTitle: 'Quote' } })
import { useRoute } from 'vue-router'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'
import { useQuoteStore } from '@/@vxapp/Quotes/useQuoteStore'
import { useQuoteFieldRead } from '@/views/Previews/Quotes/useQuoteFieldRead'
import { Subject } from '@/@vxapp/@Enums/PHP/Auth/Ability/Subjects/DataProviders/AbilitySubject'
import { ServiceType } from '@/@vxapp/@Enums/ServiceType'
import QuotesServicePage from '@/views/Previews/Quotes/QuotesServicePage.vue'

const route = useRoute()
const quotesStore = useQuoteStore()

const currentQuote = () =>
  quotesStore.quote?.quoteGUID === route.params.guid ? quotesStore.quote : null

const canReadQuoteField = useQuoteFieldRead(
  currentQuote,
  () => false,
  () => Subject.QUOTES_PREVIEW_SERVICE
)

useEntityPageTitle({
  entityName: 'Quote',
  record: () => quotesStore.quote,
  recordGuid: quote => quote.quoteGUID,
  identifier: quote => (canReadQuoteField('id') ? quote.id : null),
})

/* ** */
</script>

<template>
  <div
    class="preview-service-wrapper"
    data-testid="service-page-root"
    :data-service-type="ServiceType.Quotes.Name"
  >
    <QuotesServicePage
      :key="route.params.guid"
      :source-subject="Subject.QUOTES_PREVIEW_SERVICE"
    />
  </div>
</template>
